// src/components/CustomersSummary.js
import React from "react";

export default function CustomersSummary({ meta }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5">
      <div className="p-4 rounded-xl shadow bg-white dark:bg-gray-800">
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Total Customers
        </p>
        <h3 className="text-2xl font-semibold text-gray-800 dark:text-white">
          {meta.total || 0}
        </h3>
      </div>

      <div className="p-4 rounded-xl shadow bg-white dark:bg-gray-800">
        <p className="text-sm text-gray-500 dark:text-gray-400">Page</p>
        <h3 className="text-2xl font-semibold text-gray-800 dark:text-white">
          {meta.page || 0}
        </h3>
      </div>

      <div className="p-4 rounded-xl shadow bg-white dark:bg-gray-800">
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Total Pages
        </p>
        <h3 className="text-2xl font-semibold text-gray-800 dark:text-white">
          {meta.totalPages || 0}
        </h3>
      </div>
    </div>
  );
}
